// Platform brand colours
export const PLATFORM_COLORS = {
    youtube: '#FF0000',
    instagram: '#E1306C',
    twitter: '#1DA1F2',
    facebook: '#1877F2',
    linkedin: '#0A66C2',
    reddit: '#FF4500',
    tiktok: '#010101',
};

export const FALLBACK_COLORS = [
    '#6366f1', '#8b5cf6', '#ec4899', '#f43f5e',
    '#f97316', '#eab308', '#22c55e', '#06b6d4',
];

export function platformColor(name, index) {
    return (
        PLATFORM_COLORS[name?.toLowerCase()] ||
        FALLBACK_COLORS[index % FALLBACK_COLORS.length]
    );
}
